import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            filter: '',
            onlyActives: true,
            total: 0,
            openAddOrder: false,
            customers: [],
            types: [],
        }
    },
    computed: {
        filteredUsers() {
            return this.customers.filter(item => {
                return item.email.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.phoneNumber.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.firstName.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.lastName.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;

            })
        }
    },
    methods: {
        getUsers: getUsers,
        keymonitor: keymonitor,

        compareOrders(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },

    },
    created(){

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN') {
            this.$router.push('/login');
            return;
        }
        this.getUsers()
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getUsers();
            }
        },
    }
}



function getUsers() {
    var _self = this;
    AdminApiService.getCustomers()
        .then((response) => {
            _self.customers = response.data;
            _self.total = _self.customers.length;
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getUsers();
    }
}





// WEBPACK FOOTER //
// ./src/components/Customer/Customer.js